// @flow

import { nest } from "d3-collection";
import { sum } from "d3-array";

const json_data_factors = [
  {
    country: "United States",
    answer: "Gender",
    count: 22
  },
  {
    country: "United States",
    answer: "Level of education",
    count: 142
  },
  {
    country: "United States",
    answer: "Family responsibilities",
    count: 50
  },
  {
    country: "United States",
    answer: "Access to family capital",
    count: 18
  },
  {
    country: "United States",
    answer: "Global standing",
    count: 36
  },
  {
    country: "United States",
    answer: "Job market",
    count: 72
  },
  {
    country: "United States",
    answer: "Economic policy",
    count: 45
  },
  {
    country: "United States",
    answer: "Trade relationships",
    count: 22
  },
  {
    country: "United States",
    answer: "Ability to work abroad",
    count: 24
  },
  {
    country: "United States",
    answer: "Immigration",
    count: 14
  },
  {
    country: "United States",
    answer: "Social network",
    count: 60
  },
  {
    country: "United States",
    answer: "Tech skills",
    count: 80
  },
  {
    country: "United States",
    answer: "Foreign language skills",
    count: 24
  },
  {
    country: "United States",
    answer: "Ambition",
    count: 127
  },
  {
    country: "United States",
    answer: "Flexibility / Adaptability",
    count: 109
  },
  {
    country: "United States",
    answer: "Resilience",
    count: 90
  },
  {
    country: "United Kingdom",
    answer: "Gender",
    count: 27
  },
  {
    country: "United Kingdom",
    answer: "Level of education",
    count: 109
  },
  {
    country: "United Kingdom",
    answer: "Family responsibilities",
    count: 47
  },
  {
    country: "United Kingdom",
    answer: "Access to family capital",
    count: 38
  },
  {
    country: "United Kingdom",
    answer: "Global standing",
    count: 29
  },
  {
    country: "United Kingdom",
    answer: "Job market",
    count: 68
  },
  {
    country: "United Kingdom",
    answer: "Economic policy",
    count: 44
  },
  {
    country: "United Kingdom",
    answer: "Trade relationships",
    count: 31
  },
  {
    country: "United Kingdom",
    answer: "Ability to work abroad",
    count: 41
  },
  {
    country: "United Kingdom",
    answer: "Immigration",
    count: 17
  },
  {
    country: "United Kingdom",
    answer: "Social network",
    count: 40
  },
  {
    country: "United Kingdom",
    answer: "Tech skills",
    count: 69
  },
  {
    country: "United Kingdom",
    answer: "Foreign language skills",
    count: 30
  },
  {
    country: "United Kingdom",
    answer: "Ambition",
    count: 89
  },
  {
    country: "United Kingdom",
    answer: "Flexibility / Adaptability",
    count: 83
  },
  {
    country: "United Kingdom",
    answer: "Resilience",
    count: 60
  },
  {
    country: "Germany",
    answer: "Gender",
    count: 22
  },
  {
    country: "Germany",
    answer: "Level of education",
    count: 146
  },
  {
    country: "Germany",
    answer: "Family responsibilities",
    count: 46
  },
  {
    country: "Germany",
    answer: "Access to family capital",
    count: 35
  },
  {
    country: "Germany",
    answer: "Global standing",
    count: 35
  },
  {
    country: "Germany",
    answer: "Job market",
    count: 70
  },
  {
    country: "Germany",
    answer: "Economic policy",
    count: 31
  },
  {
    country: "Germany",
    answer: "Trade relationships",
    count: 20
  },
  {
    country: "Germany",
    answer: "Ability to work abroad",
    count: 29
  },
  {
    country: "Germany",
    answer: "Immigration",
    count: 10
  },
  {
    country: "Germany",
    answer: "Social network",
    count: 57
  },
  {
    country: "Germany",
    answer: "Tech skills",
    count: 72
  },
  {
    country: "Germany",
    answer: "Foreign language skills",
    count: 58
  },
  {
    country: "Germany",
    answer: "Ambition",
    count: 106
  },
  {
    country: "Germany",
    answer: "Flexibility / Adaptability",
    count: 93
  },
  {
    country: "Germany",
    answer: "Resilience",
    count: 96
  },
  {
    country: "Singapore",
    answer: "Gender",
    count: 17
  },
  {
    country: "Singapore",
    answer: "Level of education",
    count: 101
  },
  {
    country: "Singapore",
    answer: "Family responsibilities",
    count: 60
  },
  {
    country: "Singapore",
    answer: "Access to family capital",
    count: 23
  },
  {
    country: "Singapore",
    answer: "Global standing",
    count: 60
  },
  {
    country: "Singapore",
    answer: "Job market",
    count: 103
  },
  {
    country: "Singapore",
    answer: "Economic policy",
    count: 78
  },
  {
    country: "Singapore",
    answer: "Trade relationships",
    count: 47
  },
  {
    country: "Singapore",
    answer: "Ability to work abroad",
    count: 55
  },
  {
    country: "Singapore",
    answer: "Immigration",
    count: 21
  },
  {
    country: "Singapore",
    answer: "Social network",
    count: 65
  },
  {
    country: "Singapore",
    answer: "Tech skills",
    count: 62
  },
  {
    country: "Singapore",
    answer: "Foreign language skills",
    count: 35
  },
  {
    country: "Singapore",
    answer: "Ambition",
    count: 84
  },
  {
    country: "Singapore",
    answer: "Flexibility / Adaptability",
    count: 102
  },
  {
    country: "Singapore",
    answer: "Resilience",
    count: 83
  },
  {
    country: "Russia",
    answer: "Gender",
    count: 13
  },
  {
    country: "Russia",
    answer: "Level of education",
    count: 149
  },
  {
    country: "Russia",
    answer: "Family responsibilities",
    count: 43
  },
  {
    country: "Russia",
    answer: "Access to family capital",
    count: 20
  },
  {
    country: "Russia",
    answer: "Global standing",
    count: 41
  },
  {
    country: "Russia",
    answer: "Job market",
    count: 50
  },
  {
    country: "Russia",
    answer: "Economic policy",
    count: 64
  },
  {
    country: "Russia",
    answer: "Trade relationships",
    count: 27
  },
  {
    country: "Russia",
    answer: "Ability to work abroad",
    count: 32
  },
  {
    country: "Russia",
    answer: "Immigration",
    count: 4
  },
  {
    country: "Russia",
    answer: "Social network",
    count: 94
  },
  {
    country: "Russia",
    answer: "Tech skills",
    count: 123
  },
  {
    country: "Russia",
    answer: "Foreign language skills",
    count: 74
  },
  {
    country: "Russia",
    answer: "Ambition",
    count: 138
  },
  {
    country: "Russia",
    answer: "Flexibility / Adaptability",
    count: 164
  },
  {
    country: "Russia",
    answer: "Resilience",
    count: 147
  },
  {
    country: "China",
    answer: "Gender",
    count: 6
  },
  {
    country: "China",
    answer: "Level of education",
    count: 72
  },
  {
    country: "China",
    answer: "Family responsibilities",
    count: 50
  },
  {
    country: "China",
    answer: "Access to family capital",
    count: 61
  },
  {
    country: "China",
    answer: "Global standing",
    count: 61
  },
  {
    country: "China",
    answer: "Job market",
    count: 51
  },
  {
    country: "China",
    answer: "Economic policy",
    count: 87
  },
  {
    country: "China",
    answer: "Trade relationships",
    count: 61
  },
  {
    country: "China",
    answer: "Ability to work abroad",
    count: 25
  },
  {
    country: "China",
    answer: "Immigration",
    count: 22
  },
  {
    country: "China",
    answer: "Social network",
    count: 81
  },
  {
    country: "China",
    answer: "Tech skills",
    count: 94
  },
  {
    country: "China",
    answer: "Foreign language skills",
    count: 38
  },
  {
    country: "China",
    answer: "Ambition",
    count: 70
  },
  {
    country: "China",
    answer: "Flexibility / Adaptability",
    count: 81
  },
  {
    country: "China",
    answer: "Resilience",
    count: 55
  },
  {
    country: "India",
    answer: "Gender",
    count: 78
  },
  {
    country: "India",
    answer: "Level of education",
    count: 117
  },
  {
    country: "India",
    answer: "Family responsibilities",
    count: 110
  },
  {
    country: "India",
    answer: "Access to family capital",
    count: 70
  },
  {
    country: "India",
    answer: "Global standing",
    count: 86
  },
  {
    country: "India",
    answer: "Job market",
    count: 97
  },
  {
    country: "India",
    answer: "Economic policy",
    count: 86
  },
  {
    country: "India",
    answer: "Trade relationships",
    count: 69
  },
  {
    country: "India",
    answer: "Ability to work abroad",
    count: 86
  },
  {
    country: "India",
    answer: "Immigration",
    count: 47
  },
  {
    country: "India",
    answer: "Social network",
    count: 93
  },
  {
    country: "India",
    answer: "Tech skills",
    count: 94
  },
  {
    country: "India",
    answer: "Foreign language skills",
    count: 52
  },
  {
    country: "India",
    answer: "Ambition",
    count: 80
  },
  {
    country: "India",
    answer: "Flexibility / Adaptability",
    count: 67
  },
  {
    country: "India",
    answer: "Resilience",
    count: 33
  },
  {
    country: "United Arab Emirates",
    answer: "Gender",
    count: 34
  },
  {
    country: "United Arab Emirates",
    answer: "Level of education",
    count: 131
  },
  {
    country: "United Arab Emirates",
    answer: "Family responsibilities",
    count: 70
  },
  {
    country: "United Arab Emirates",
    answer: "Access to family capital",
    count: 42
  },
  {
    country: "United Arab Emirates",
    answer: "Global standing",
    count: 56
  },
  {
    country: "United Arab Emirates",
    answer: "Job market",
    count: 102
  },
  {
    country: "United Arab Emirates",
    answer: "Economic policy",
    count: 71
  },
  {
    country: "United Arab Emirates",
    answer: "Trade relationships",
    count: 48
  },
  {
    country: "United Arab Emirates",
    answer: "Ability to work abroad",
    count: 59
  },
  {
    country: "United Arab Emirates",
    answer: "Immigration",
    count: 30
  },
  {
    country: "United Arab Emirates",
    answer: "Social network",
    count: 60
  },
  {
    country: "United Arab Emirates",
    answer: "Tech skills",
    count: 81
  },
  {
    country: "United Arab Emirates",
    answer: "Foreign language skills",
    count: 69
  },
  {
    country: "United Arab Emirates",
    answer: "Ambition",
    count: 90
  },
  {
    country: "United Arab Emirates",
    answer: "Flexibility / Adaptability",
    count: 79
  },
  {
    country: "United Arab Emirates",
    answer: "Resilience",
    count: 37
  },
  {
    country: "Mexico",
    answer: "Gender",
    count: 15
  },
  {
    country: "Mexico",
    answer: "Level of education",
    count: 162
  },
  {
    country: "Mexico",
    answer: "Family responsibilities",
    count: 34
  },
  {
    country: "Mexico",
    answer: "Access to family capital",
    count: 28
  },
  {
    country: "Mexico",
    answer: "Global standing",
    count: 21
  },
  {
    country: "Mexico",
    answer: "Job market",
    count: 62
  },
  {
    country: "Mexico",
    answer: "Economic policy",
    count: 54
  },
  {
    country: "Mexico",
    answer: "Trade relationships",
    count: 35
  },
  {
    country: "Mexico",
    answer: "Ability to work abroad",
    count: 62
  },
  {
    country: "Mexico",
    answer: "Immigration",
    count: 7
  },
  {
    country: "Mexico",
    answer: "Social network",
    count: 68
  },
  {
    country: "Mexico",
    answer: "Tech skills",
    count: 114
  },
  {
    country: "Mexico",
    answer: "Foreign language skills",
    count: 90
  },
  {
    country: "Mexico",
    answer: "Ambition",
    count: 109
  },
  {
    country: "Mexico",
    answer: "Flexibility / Adaptability",
    count: 123
  },
  {
    country: "Mexico",
    answer: "Resilience",
    count: 61
  },
  {
    country: "South Africa",
    answer: "Gender",
    count: 31
  },
  {
    country: "South Africa",
    answer: "Level of education",
    count: 169
  },
  {
    country: "South Africa",
    answer: "Family responsibilities",
    count: 72
  },
  {
    country: "South Africa",
    answer: "Access to family capital",
    count: 22
  },
  {
    country: "South Africa",
    answer: "Global standing",
    count: 48
  },
  {
    country: "South Africa",
    answer: "Job market",
    count: 88
  },
  {
    country: "South Africa",
    answer: "Economic policy",
    count: 70
  },
  {
    country: "South Africa",
    answer: "Trade relationships",
    count: 46
  },
  {
    country: "South Africa",
    answer: "Ability to work abroad",
    count: 71
  },
  {
    country: "South Africa",
    answer: "Immigration",
    count: 17
  },
  {
    country: "South Africa",
    answer: "Social network",
    count: 55
  },
  {
    country: "South Africa",
    answer: "Tech skills",
    count: 125
  },
  {
    country: "South Africa",
    answer: "Foreign language skills",
    count: 27
  },
  {
    country: "South Africa",
    answer: "Ambition",
    count: 151
  },
  {
    country: "South Africa",
    answer: "Flexibility / Adaptability",
    count: 130
  },
  {
    country: "South Africa",
    answer: "Resilience",
    count: 112
  },
  {
    country: "Developed markets",
    answer: "Gender",
    count: 88
  },
  {
    country: "Developed markets",
    answer: "Level of education",
    count: 498
  },
  {
    country: "Developed markets",
    answer: "Family responsibilities",
    count: 203
  },
  {
    country: "Developed markets",
    answer: "Access to family capital",
    count: 114
  },
  {
    country: "Developed markets",
    answer: "Global standing",
    count: 160
  },
  {
    country: "Developed markets",
    answer: "Job market",
    count: 313
  },
  {
    country: "Developed markets",
    answer: "Economic policy",
    count: 198
  },
  {
    country: "Developed markets",
    answer: "Trade relationships",
    count: 120
  },
  {
    country: "Developed markets",
    answer: "Ability to work abroad",
    count: 149
  },
  {
    country: "Developed markets",
    answer: "Immigration",
    count: 62
  },
  {
    country: "Developed markets",
    answer: "Social network",
    count: 222
  },
  {
    country: "Developed markets",
    answer: "Tech skills",
    count: 283
  },
  {
    country: "Developed markets",
    answer: "Foreign language skills",
    count: 147
  },
  {
    country: "Developed markets",
    answer: "Ambition",
    count: 406
  },
  {
    country: "Developed markets",
    answer: "Flexibility / Adaptability",
    count: 387
  },
  {
    country: "Developed markets",
    answer: "Resilience",
    count: 329
  },
  {
    country: "Emerging markets",
    answer: "Gender",
    count: 97
  },
  {
    country: "Emerging markets",
    answer: "Level of education",
    count: 338
  },
  {
    country: "Emerging markets",
    answer: "Family responsibilities",
    count: 203
  },
  {
    country: "Emerging markets",
    answer: "Access to family capital",
    count: 151
  },
  {
    country: "Emerging markets",
    answer: "Global standing",
    count: 188
  },
  {
    country: "Emerging markets",
    answer: "Job market",
    count: 198
  },
  {
    country: "Emerging markets",
    answer: "Economic policy",
    count: 237
  },
  {
    country: "Emerging markets",
    answer: "Trade relationships",
    count: 157
  },
  {
    country: "Emerging markets",
    answer: "Ability to work abroad",
    count: 143
  },
  {
    country: "Emerging markets",
    answer: "Immigration",
    count: 73
  },
  {
    country: "Emerging markets",
    answer: "Social network",
    count: 268
  },
  {
    country: "Emerging markets",
    answer: "Tech skills",
    count: 311
  },
  {
    country: "Emerging markets",
    answer: "Foreign language skills",
    count: 164
  },
  {
    country: "Emerging markets",
    answer: "Ambition",
    count: 288
  },
  {
    country: "Emerging markets",
    answer: "Flexibility / Adaptability",
    count: 312
  },
  {
    country: "Emerging markets",
    answer: "Resilience",
    count: 235
  }
];

const json_data_wealthMillennials = [
  {
    country: "United States",
    answer: "Well connected",
    count: 7,
    question: "q1"
  },
  {
    country: "United States",
    answer: "Philanthropy",
    count: 14,
    question: "q1"
  },
  {
    country: "United States",
    answer: "Luxury",
    count: 19,
    question: "q1"
  },
  {
    country: "United States",
    answer: "Exciting experiences",
    count: 117,
    question: "q1"
  },
  {
    country: "United States",
    answer: "Legacy for family",
    count: 40,
    question: "q1"
  },
  {
    country: "United States",
    answer: "Social Status",
    count: 8,
    question: "q1"
  },
  {
    country: "United States",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Well connected",
    count: 19,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Philanthropy",
    count: 25,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Luxury",
    count: 18,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Exciting experiences",
    count: 88,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Legacy for family",
    count: 43,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "Social Status",
    count: 17,
    question: "q1"
  },
  {
    country: "United Kingdom",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Well connected",
    count: 31,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Philanthropy",
    count: 11,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Luxury",
    count: 32,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Exciting experiences",
    count: 72,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Legacy for family",
    count: 54,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "Social Status",
    count: 14,
    question: "q1"
  },
  {
    country: "Germany",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Well connected",
    count: 19,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Philanthropy",
    count: 12,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Luxury",
    count: 47,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Exciting experiences",
    count: 104,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Legacy for family",
    count: 24,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "Social Status",
    count: 7,
    question: "q1"
  },
  {
    country: "Singapore",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Well connected",
    count: 32,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Philanthropy",
    count: 17,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Luxury",
    count: 40,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Exciting experiences",
    count: 74,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Legacy for family",
    count: 76,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "Social Status",
    count: 10,
    question: "q1"
  },
  {
    country: "Russia",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "China",
    answer: "Well connected",
    count: 43,
    question: "q1"
  },
  {
    country: "China",
    answer: "Philanthropy",
    count: 10,
    question: "q1"
  },
  {
    country: "China",
    answer: "Luxury",
    count: 31,
    question: "q1"
  },
  {
    country: "China",
    answer: "Exciting experiences",
    count: 90,
    question: "q1"
  },
  {
    country: "China",
    answer: "Legacy for family",
    count: 24,
    question: "q1"
  },
  {
    country: "China",
    answer: "Social Status",
    count: 22,
    question: "q1"
  },
  {
    country: "China",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "India",
    answer: "Well connected",
    count: 28,
    question: "q1"
  },
  {
    country: "India",
    answer: "Philanthropy",
    count: 26,
    question: "q1"
  },
  {
    country: "India",
    answer: "Luxury",
    count: 38,
    question: "q1"
  },
  {
    country: "India",
    answer: "Exciting experiences",
    count: 39,
    question: "q1"
  },
  {
    country: "India",
    answer: "Legacy for family",
    count: 38,
    question: "q1"
  },
  {
    country: "India",
    answer: "Social Status",
    count: 34,
    question: "q1"
  },
  {
    country: "India",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Well connected",
    count: 37,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Philanthropy",
    count: 41,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Luxury",
    count: 38,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Exciting experiences",
    count: 34,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Legacy for family",
    count: 36,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "Social Status",
    count: 21,
    question: "q1"
  },
  {
    country: "United Arab Emirates",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Well connected",
    count: 18,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Philanthropy",
    count: 20,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Luxury",
    count: 27,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Exciting experiences",
    count: 79,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Legacy for family",
    count: 54,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "Social Status",
    count: 8,
    question: "q1"
  },
  {
    country: "Mexico",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Well connected",
    count: 15,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Philanthropy",
    count: 33,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Luxury",
    count: 13,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Exciting experiences",
    count: 74,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Legacy for family",
    count: 64,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "Social Status",
    count: 4,
    question: "q1"
  },
  {
    country: "South Africa",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Well connected",
    count: 76,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Philanthropy",
    count: 62,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Luxury",
    count: 116,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Exciting experiences",
    count: 381,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Legacy for family",
    count: 161,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "Social Status",
    count: 46,
    question: "q1"
  },
  {
    country: "Developed markets",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Well connected",
    count: 173,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Philanthropy",
    count: 147,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Luxury",
    count: 187,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Exciting experiences",
    count: 390,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Legacy for family",
    count: 292,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "Social Status",
    count: 99,
    question: "q1"
  },
  {
    country: "Emerging markets",
    answer: "None of these",
    count: 0,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Well connected",
    count: 249,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Philanthropy",
    count: 209,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Luxury",
    count: 303,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Exciting experiences",
    count: 771,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Legacy for family",
    count: 453,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "Social Status",
    count: 145,
    question: "q1"
  },
  {
    country: "All countries",
    answer: "None of these",
    count: 0,
    question: "q1"
  }
];

const json_data_wealthParents = [
  {
    country: "United States",
    answer: "Well connected",
    count: 28,
    question: "q4"
  },
  {
    country: "United States",
    answer: "Philanthropy",
    count: 12,
    question: "q4"
  },
  {
    country: "United States",
    answer: "Luxury",
    count: 29,
    question: "q4"
  },
  {
    country: "United States",
    answer: "Exciting experiences",
    count: 49,
    question: "q4"
  },
  {
    country: "United States",
    answer: "Legacy for family",
    count: 70,
    question: "q4"
  },
  {
    country: "United States",
    answer: "Social Status",
    count: 8,
    question: "q4"
  },
  {
    country: "United States",
    answer: "None of these",
    count: 9,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Well connected",
    count: 37,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Philanthropy",
    count: 23,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Luxury",
    count: 29,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Exciting experiences",
    count: 53,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Legacy for family",
    count: 56,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "Social Status",
    count: 4,
    question: "q4"
  },
  {
    country: "United Kingdom",
    answer: "None of these",
    count: 8,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Well connected",
    count: 48,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Philanthropy",
    count: 19,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Luxury",
    count: 23,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Exciting experiences",
    count: 25,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Legacy for family",
    count: 70,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "Social Status",
    count: 14,
    question: "q4"
  },
  {
    country: "Germany",
    answer: "None of these",
    count: 15,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Well connected",
    count: 21,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Philanthropy",
    count: 19,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Luxury",
    count: 60,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Exciting experiences",
    count: 32,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Legacy for family",
    count: 66,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "Social Status",
    count: 6,
    question: "q4"
  },
  {
    country: "Singapore",
    answer: "None of these",
    count: 9,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Well connected",
    count: 30,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Philanthropy",
    count: 14,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Luxury",
    count: 42,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Exciting experiences",
    count: 21,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Legacy for family",
    count: 105,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "Social Status",
    count: 17,
    question: "q4"
  },
  {
    country: "Russia",
    answer: "None of these",
    count: 20,
    question: "q4"
  },
  {
    country: "China",
    answer: "Well connected",
    count: 71,
    question: "q4"
  },
  {
    country: "China",
    answer: "Philanthropy",
    count: 21,
    question: "q4"
  },
  {
    country: "China",
    answer: "Luxury",
    count: 22,
    question: "q4"
  },
  {
    country: "China",
    answer: "Exciting experiences",
    count: 57,
    question: "q4"
  },
  {
    country: "China",
    answer: "Legacy for family",
    count: 27,
    question: "q4"
  },
  {
    country: "China",
    answer: "Social Status",
    count: 19,
    question: "q4"
  },
  {
    country: "China",
    answer: "None of these",
    count: 3,
    question: "q4"
  },
  {
    country: "India",
    answer: "Well connected",
    count: 72,
    question: "q4"
  },
  {
    country: "India",
    answer: "Philanthropy",
    count: 38,
    question: "q4"
  },
  {
    country: "India",
    answer: "Luxury",
    count: 25,
    question: "q4"
  },
  {
    country: "India",
    answer: "Exciting experiences",
    count: 29,
    question: "q4"
  },
  {
    country: "India",
    answer: "Legacy for family",
    count: 25,
    question: "q4"
  },
  {
    country: "India",
    answer: "Social Status",
    count: 13,
    question: "q4"
  },
  {
    country: "India",
    answer: "None of these",
    count: 1,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Well connected",
    count: 44,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Philanthropy",
    count: 50,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Luxury",
    count: 34,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Exciting experiences",
    count: 10,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Legacy for family",
    count: 41,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "Social Status",
    count: 22,
    question: "q4"
  },
  {
    country: "United Arab Emirates",
    answer: "None of these",
    count: 6,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Well connected",
    count: 32,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Philanthropy",
    count: 13,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Luxury",
    count: 24,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Exciting experiences",
    count: 24,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Legacy for family",
    count: 86,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "Social Status",
    count: 10,
    question: "q4"
  },
  {
    country: "Mexico",
    answer: "None of these",
    count: 17,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Well connected",
    count: 12,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Philanthropy",
    count: 26,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Luxury",
    count: 30,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Exciting experiences",
    count: 35,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Legacy for family",
    count: 85,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "Social Status",
    count: 3,
    question: "q4"
  },
  {
    country: "South Africa",
    answer: "None of these",
    count: 12,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Well connected",
    count: 134,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Philanthropy",
    count: 73,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Luxury",
    count: 141,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Exciting experiences",
    count: 159,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Legacy for family",
    count: 262,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "Social Status",
    count: 32,
    question: "q4"
  },
  {
    country: "Developed markets",
    answer: "None of these",
    count: 41,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Well connected",
    count: 261,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Philanthropy",
    count: 162,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Luxury",
    count: 177,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Exciting experiences",
    count: 176,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Legacy for family",
    count: 369,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "Social Status",
    count: 84,
    question: "q4"
  },
  {
    country: "Emerging markets",
    answer: "None of these",
    count: 59,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Well connected",
    count: 395,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Philanthropy",
    count: 235,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Luxury",
    count: 318,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Exciting experiences",
    count: 335,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Legacy for family",
    count: 631,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "Social Status",
    count: 116,
    question: "q4"
  },
  {
    country: "All countries",
    answer: "None of these",
    count: 100,
    question: "q4"
  }
];

export const factors = nest()
  .key(d => d.country)
  .key(d => d.answer)
  .rollup(values => sum(values, d => d.count))
  .entries(json_data_factors)
  .map((d, i) => {
    return {
      country: d.key,
      answers: d.values
    };
  });
//})

export const wealthMillennials = nest()
  .key(d => d.country)
  .key(d => d.answer)
  .rollup(values => sum(values, d => d.count))
  .entries(json_data_wealthMillennials)
  .map((d, i) => {
    return {
      country: d.key,
      answers: d.values
    };
  });
export const wealthParents = nest()
  .key(d => d.country)
  .key(d => d.answer)
  .rollup(values => sum(values, d => d.count))
  .entries(json_data_wealthParents)
  .map((d, i) => {
    return {
      country: d.key,
      answers: d.values
    };
  });



// WEBPACK FOOTER //
// ./src/data/chartData.js